export const fbMapper = (snap) => {
  const output = [];
  snap.forEach((doc) => {
    output.push({ ...doc.data(), uid: doc.id });
  });
  return output;
};
